import { useState } from 'react';
import { useSearchParamsWithApiKey, useDebouncedEffect } from '../../tools';

const IMAGE_URL = 'imageUrl';
const STYLE_SELECTED_OPTION = 'styleSelectedOption';
const BACKGROUND_PROMPT = 'backgroundPrompt';
const BACKGROUND_MODE_SELECTED_OPTION = 'backgroundModeSelectedOption';

interface UseStylizePhotoParams {
    imageUrl: string;
    styleValue: string;
    backgroundModeValue: string;
    backgroundPrompt: string;
    setImageUrl: (imageUrl: string) => void;
    setStyleValue: (styleValue: string) => void;
    setBackgroundModeValue: (backgroundModeValue: string) => void;
    setBackgroundPrompt: (backgroundPrompt: string) => void;
}

export const useStylizePhotoParams = (): UseStylizePhotoParams => {
    const [searchParams, setSearchParams] = useSearchParamsWithApiKey();
    const imageUrlParam = searchParams.get(IMAGE_URL);
    const styleValueParam = searchParams.get(STYLE_SELECTED_OPTION);
    const backgroundModeValueParam = searchParams.get(BACKGROUND_MODE_SELECTED_OPTION);
    const backgroundPromptParam = searchParams.get(BACKGROUND_PROMPT);

    const [imageUrl, setImageUrl] = useState<string>(imageUrlParam ?? '');
    const [styleValue, setStyleValue] = useState<string>(styleValueParam ?? '');
    const [backgroundModeValue, setBackgroundModeValue] = useState<string>(backgroundModeValueParam ?? '');
    const [backgroundPrompt, setBackgroundPrompt] = useState<string>(backgroundPromptParam ?? '');

    useDebouncedEffect(
        () => {
            const searchParamsObj: Record<string, string> = {};

            if (imageUrl) {
                searchParamsObj['imageUrl'] = imageUrl;
            }
            if (styleValue) {
                searchParamsObj['styleSelectedOption'] = styleValue;
            }
            if (backgroundModeValue) {
                searchParamsObj['backgroundModeSelectedOption'] = backgroundModeValue;
            }
            if (backgroundPrompt) {
                searchParamsObj['backgroundPrompt'] = backgroundPrompt;
            }

            setSearchParams(searchParamsObj);
        },
        [imageUrl, styleValue, backgroundModeValue, backgroundPrompt, setSearchParams],
        500,
    );

    return {
        imageUrl,
        styleValue,
        backgroundModeValue,
        backgroundPrompt,
        setImageUrl,
        setStyleValue,
        setBackgroundModeValue,
        setBackgroundPrompt,
    };
};
